<template>
  <div class="card-wrapper">
    <b-card v-for="deliveryTerm in deliveryTerms" :key="deliveryTerm.id" class="mb-3">
      <div class="d-xs-flex justify-content-between align-items-center">
        <div class="d-lg-flex d-block flex-grow-1">
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ deliveryTerm.city }}
          </p>
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ deliveryTerm.term }}
          </p>
        </div>

        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i
            @click="showInfoModal(deliveryTerm.id)"
            class="glyph-icon simple-icon-pencil datalist-icon mr-md-3 mr-2"
          ></i>

          <i @click="handleDelete(deliveryTerm.id)" class="glyph-icon simple-icon-trash datalist-icon"></i>
        </div>
      </div>
    </b-card>

    <!-- Modals -->
    <b-modal id="editDeliveryTermModal" ref="editDeliveryTermModal" size="lg" :title="'Edit delivery term'">
      <b-row v-if="!isLoading">
        <b-colxx xxs="12">
          <b-card class="mb-4">
            <b-form @submit.prevent="onSubmit" class="av-tooltip">
              <b-form-group :label="`${$t('pages.deliveryTerms.city')} (EN)`">
                <b-form-input type="text" v-model="$v.editForm.cityEn.$model" :state="!$v.editForm.cityEn.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.cityEn.required">
                  {{ $t('formErrors.enterCity') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="`${$t('pages.deliveryTerms.city')} (RU)`">
                <b-form-input type="text" v-model="$v.editForm.cityRu.$model" :state="!$v.editForm.cityRu.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.cityRu.required">
                  {{ $t('formErrors.enterCity') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="`${$t('pages.deliveryTerms.term')} (EN)`">
                <b-form-input type="text" v-model="$v.editForm.termEn.$model" :state="!$v.editForm.termEn.$error" />

                <b-form-invalid-feedback v-if="!$v.editForm.termEn.required">
                  {{ $t('formErrors.enterTerm') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="`${$t('pages.deliveryTerms.term')} (RU)`">
                <b-form-input type="text" v-model="$v.editForm.termRu.$model" :state="!$v.editForm.termRu.$error" />

                <b-form-invalid-feedback v-if="!$v.editForm.termRu.required">
                  {{ $t('formErrors.enterTerm') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pages.deliveryTerms.minPrice')">
                <b-form-input type="text" v-model="$v.editForm.minPrice.$model" :state="!$v.editForm.minPrice.$error" />

                <b-form-invalid-feedback v-if="!$v.editForm.minPrice.required">
                  {{ $t('formErrors.enterMinPrice') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pages.deliveryTerms.price')">
                <b-form-input type="text" v-model="$v.editForm.price.$model" :state="!$v.editForm.price.$error" />

                <b-form-invalid-feedback v-if="!$v.editForm.price.required">
                  {{ $t('formErrors.enterPrice') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-button type="submit" variant="primary" class="mt-2">
                {{ $t('buttons.save') }}
              </b-button>
            </b-form>
          </b-card>
        </b-colxx>
      </b-row>
      <div v-else class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>

      <template slot="modal-footer">
        <b-button variant="secondary" @click="hideModal('editDeliveryTermModal')">
          {{ $t('buttons.cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
const { required } = require('vuelidate/lib/validators')

export default {
  props: {
    deliveryTerms: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      editForm: {
        cityEn: '',
        cityRu: '',
        termEn: '',
        termRu: '',
        minPrice: null,
        price: null
      },
      currentDeliveryTerm: null
    }
  },
  validations: {
    editForm: {
      cityEn: { required },
      cityRu: { required },
      termEn: { required },
      termRu: { required },
      minPrice: { required },
      price: { required }
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', (_bvEvent, modalId) => {
      if (modalId === 'editDeliveryTermModal') {
        this.clearForm()
      }
    })
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 3000, permanent: false })
    },
    handleDelete(id) {
      this.$confirm({
        message: this.$t('confirm-dialog.question'),
        button: {
          no: this.$t('confirm-dialog.no'),
          yes: this.$t('confirm-dialog.yes')
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('deliveryTerms/deleteDeliveryTerm', {
              id,
              vm: this
            })
          }
        }
      })
    },
    showInfoModal(id) {
      this.$bvModal.show('editDeliveryTermModal')
      this.$store.dispatch('deliveryTerms/fetchDeliveryTerm', { id, vm: this })
      this.currentDeliveryTerm = id
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          city_en: this.editForm.cityEn,
          city_ru: this.editForm.cityRu,
          term_en: this.editForm.termEn,
          term_ru: this.editForm.termRu,
          min_price: this.editForm.minPrice,
          price: this.editForm.price
        }

        this.$store.dispatch('deliveryTerms/updateDeliveryTerm', {
          payload,
          id: this.currentDeliveryTerm,
          vm: this
        })
      }
    },
    clearForm() {
      this.editForm.cityEn = ''
      this.editForm.cityRu = ''
      this.editForm.termEn = ''
      this.editForm.termRu = ''
      this.editForm.minPrice = null
      this.editForm.price = null
      this.currentDeliveryTerm = null
    },
    hideModal(refname) {
      this.$refs[refname].hide()
    }
  }
}
</script>
